import { usePathname } from 'next/navigation'

const usePatientIsActive = () => {
  const pathname = usePathname()

  const patientIsActive = pathname.startsWith('/dashboard/patients')

  return patientIsActive
}

export default usePatientIsActive
